module.exports = __webpack_public_path__ + "static/media/gameConstructionMaze.bf5f0c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameConstructionMaze.png
// module id = 2570
// module chunks = 0